"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var error_stack_parser_1 = __importDefault(require("error-stack-parser"));
var onceAndDebug = function (original) {
    var hasFired = false;
    var cachedValue = null;
    var prevCall = error_stack_parser_1.default.parse(Error(''))[1] || {
        functionName: '<unknown>',
    };
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (hasFired) {
            console.warn('Function silenced', prevCall);
            return cachedValue;
        }
        hasFired = true;
        cachedValue = original.apply(void 0, __spread(args));
        return cachedValue;
    };
};
exports.default = onceAndDebug;
